import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react"
import { useDownloadUsers } from "./DownloadUsersContext";
import { Box, Button, Card, CardContent, CardHeader, Checkbox, Dialog, FormControlLabel, FormGroup, Grid, IconButton, Table, TableBody ,TableCell, TableRow, TextField, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { updateUserAcc, deleteUserAcc } from "./utils";

const DownloadUserAccForm = () =>{
    const [open, setOpen] = useState(false);
    const [name, setName] = useState("");
    const [textFieldError, setTextFieldError] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const {
      downloadUserAcc, 
      setDownloadUserAcc, 
      selectedDownloadUserAcc, 
      setSelectedDownloadUserAcc, 
      setReload, 
      roles, 
      setRoles, 
      selectedRoleBtn, 
      setSelectedRoleBtn
    } = useDownloadUsers();

    useEffect(() => {
        setOpen(selectedDownloadUserAcc !==null && downloadUserAcc !== null )
    },[selectedDownloadUserAcc, downloadUserAcc])

    const onClose = (e, reason) => {
        setSelectedDownloadUserAcc(null);
        setDownloadUserAcc(null);
        setRoles(null);
        setFormErrors({})
      };

    const handleChange = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      setDownloadUserAcc((prev) => ({ ...prev, [name]: value }));
    };

    const handleRoleBtn = (e) => {
      setSelectedRoleBtn(true)
    }

    const handleAddressChange = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      let address =downloadUserAcc.address;
      address[name]=value  
      setDownloadUserAcc((prev) => ({ ...prev, [address]: address }));
    };

    const formValidate = (selectedDownloadUserAcc) => {
      let newFormErrors = {};
      if(selectedDownloadUserAcc.login===null || (selectedDownloadUserAcc.login).trim() ===""){
        newFormErrors.login="Please Enter Login Name"
        setFormErrors(newFormErrors)
      }
      if(selectedDownloadUserAcc.name === null || (selectedDownloadUserAcc.name).trim() === ""){
        newFormErrors.name="Please Enter Name"
        setFormErrors(newFormErrors)
      }

      if(selectedDownloadUserAcc.email === null || (selectedDownloadUserAcc.email).trim() === ""){
        newFormErrors.email="Please Enter Email Id"
        setFormErrors(newFormErrors)
      }

      if(selectedDownloadUserAcc.company === null || (selectedDownloadUserAcc.company).trim() === ""){
        newFormErrors.company = "Please Enter Organization Name"
        setFormErrors(newFormErrors)
      }

      if(selectedDownloadUserAcc.phoneNumber === null || (selectedDownloadUserAcc.phoneNumber).trim() === ""){
        newFormErrors.phoneNumber = "Please Enter Phone Number"
        setFormErrors(newFormErrors)
      }

      if(selectedDownloadUserAcc.jobTitle === null || (selectedDownloadUserAcc.jobTitle).trim() === ""){
        newFormErrors.jobTitle = "Please Enter Job Title"
        setFormErrors(newFormErrors)
      }

      if(selectedDownloadUserAcc.address.street === null || (selectedDownloadUserAcc.address.street).trim() === ""){
        newFormErrors.street = "Please Enter Street Address"
        setFormErrors(newFormErrors)
      }

      if(selectedDownloadUserAcc.address.city === null || (selectedDownloadUserAcc.address.city).trim() === ""){
        newFormErrors.city = "Please Enter City"
        setFormErrors(newFormErrors)
      }

      if(selectedDownloadUserAcc.address.state === null || (selectedDownloadUserAcc.address.state).trim() === ""){
        newFormErrors.state = "Please Enter State"
        setFormErrors(newFormErrors)
      }

      if(selectedDownloadUserAcc.address.zip === null || (selectedDownloadUserAcc.address.zip).trim() === ""){
        newFormErrors.zip = "Please Enter Zip Code"
        setFormErrors(newFormErrors)
      }

      if(selectedDownloadUserAcc.intendedUsage === null || (selectedDownloadUserAcc.intendedUsage).trim() === ""){
        newFormErrors.intendedUsage = "Intended Usage"
        setFormErrors(newFormErrors)
      }


      if(Object.keys(newFormErrors).length>0)
        return false
        
      else
        return true
  }
    
    const updtUserAcc = (selectedDownloadUserAcc) => {
      if (formValidate(selectedDownloadUserAcc)){
      updateUserAcc(selectedDownloadUserAcc).then(() => {
        setSelectedDownloadUserAcc(null);
        setDownloadUserAcc(null);
        setReload(true);
        setFormErrors({})
      })
    }
    // else 
    // alert("Please make sure input the required fields before submit");
  }

    const delUserAcc = (selectedDownloadUserAcc) => {
      deleteUserAcc(selectedDownloadUserAcc).then(() => {
        setSelectedDownloadUserAcc(null);
        setDownloadUserAcc(null);
        setReload(true);
      })
    }

    return (
        downloadUserAcc && (
            <Dialog maxWidth="true" open={open} onClose={onClose}>
              <IconButton
                aria-label="close"
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                }}
                onClick={onClose}
              >
                <CloseIcon />
              </IconButton>
              <Card sx={{ borderRadius: 3 }}>
                <CardHeader
                  title={<font className="layer-title"> Download User Account Form </font>}
                  align="center"
                  className={"styledtablerow"}
                />
                <CardContent
                  sx={{
                    paddingTop: 1,
                    paddingLeft: 0,
                    paddingRight: 0,
                    overflow: "auto",
                  }}
                >
                  <Box component="form" size='small'
                    sx={{ '& .MuiTextField-root': { m: 1, width: '35ch' }, paddingTop:3, paddingLeft:2, align:'center'}}>
                    <Grid container spacing={{ xs: 1}}  justifyContent={"space-between"}>
                      <Grid alignItems={"stretch"}>
                        <Table size="small">
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField
                                disabled
                                size="small"
                                id="download-user-id"
                                label="ID"
                                value={downloadUserAcc.id}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth 
                                required
                                id="download-user-login"
                                label="login"
                                size="small"
                                name="login"
                                value={downloadUserAcc.login}
                                onChange={handleChange}
                                error={formErrors.login}
                                helperText={formErrors.login}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth 
                                id="download-user-password"
                                label="password"
                                size="small"
                                name="password"
                                value={downloadUserAcc.password}
                                onChange={handleChange}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth 
                                required
                                id="download-user-name"
                                label="Name"
                                size="small"
                                name="name"
                                value={downloadUserAcc.name}
                                onChange={handleChange}
                                error={formErrors.name}
                                helperText={formErrors.name}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth 
                                required
                                id="download-user-email"
                                label="Email"
                                size="small"
                                name="email"
                                value={downloadUserAcc.email}
                                onChange={handleChange}
                                error={formErrors.email}
                                helperText={formErrors.email}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth 
                                required
                                id="user-organizationName"
                                label="Organization Name"
                                size="small"
                                name="company"
                                value={downloadUserAcc.company}
                                onChange={handleChange}
                                error={formErrors.company}
                                helperText={formErrors.company}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth 
                                required
                                id="download-user-contact"
                                label="Phone Number"
                                size="small"
                                name="phoneNumber"
                                value={downloadUserAcc.phoneNumber}
                                onChange={handleChange}
                                error={formErrors.phoneNumber}
                                helperText={formErrors.phoneNumber}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth 
                                required
                                id="download-user-jobTitle"
                                label="Job Title"
                                size="small"
                                name="jobTitle"
                                value={downloadUserAcc.jobTitle}
                                onChange={handleChange}
                                error={formErrors.jobTitle}
                                helperText={formErrors.jobTitle}
                              />
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                      <Grid>
                        <Table size="small">
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth 
                                required
                                id="download-user-streetAddress"
                                label="Street Address"
                                size="small"
                                name="street"
                                value={downloadUserAcc.address.street}
                                onChange={handleAddressChange}
                                error={formErrors.street}
                                helperText={formErrors.street}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth 
                                required
                                id="download-user-city"
                                label="City"
                                size="small"
                                name="city"
                                value={downloadUserAcc.address.city}
                                onChange={handleAddressChange}
                                error={formErrors.city}
                                helperText={formErrors.city}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth 
                                required
                                id="download-user-state"
                                label="State"
                                size="small"
                                name="state"
                                value={downloadUserAcc.address.state}
                                onChange={handleAddressChange}
                                error={formErrors.state}
                                helperText={formErrors.state}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth 
                                required
                                id="download-user-zipcode"
                                label="Zip Code"
                                size="small"
                                name="zip"
                                value={downloadUserAcc.address.zip}
                                onChange={handleAddressChange}
                                error={formErrors.zip}
                                helperText={formErrors.zip}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth 
                                id="download-user-faxNumber"
                                label="Fax Number"
                                size="small"
                                name="faxNumber"
                                value={downloadUserAcc.faxNumber}
                                onChange={handleChange}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth 
                                id="download-user-ipAddress"
                                label="IP Address"
                                size="small"
                                name="ipAddress"
                                value={downloadUserAcc.ipAddress}
                                onChange={handleChange}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth
                                required
                                id="download-user-intendedUsage"
                                label="Intended Usage" 
                                size="small"
                                name="intendedUsage"
                                value={downloadUserAcc.intendedUsage}
                                onChange={handleChange}
                                error={formErrors.intendedUsage}
                                helperText={formErrors.intendedUsage}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <TextField fullWidth 
                                id="download-user-intendedLocation"
                                label="Intended Location"
                                size="small"
                                name="intendedLocation"
                                value={downloadUserAcc.intendedLocation}
                                onChange={handleChange}
                              />
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                      <Grid >
                        <Table size="small">
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              {(downloadUserAcc.roles && downloadUserAcc.roles.length > 0 && 
                                <Typography>
                                  {JSON.stringify(downloadUserAcc.roles)}
                                </Typography>
                               )}
                               <Button variant="outlined" label="SelectRoles" name="userRoles" value={downloadUserAcc.roles} onClick={handleRoleBtn}> Select Roles </Button>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <DatePicker 
                                id = "download-user-approvedDate"
                                label = "Approved Date"
                                value={downloadUserAcc.approved}
                                onChange={(newValue) => {
                                  setDownloadUserAcc((downloadUserAcc) => {
                                  return { ...downloadUserAcc, approved: newValue };
                                  });
                                }}
                                renderInput={(params) => <TextField size='small' {...params} error={false}/>}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <DatePicker 
                                id = "download-user-agreementSent"
                                label = "Agreement Sent"
                                value={downloadUserAcc.agreementSent}
                                onChange={(newValue) => {
                                  setDownloadUserAcc((downloadUserAcc) => {
                                  return { ...downloadUserAcc, agreementSent: newValue };
                                  });
                                }}
                                renderInput={(params) => <TextField size='small' {...params} error={false}/>}
                              />  
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>  
                              <DatePicker
                                id = "download-user-agreementReceived"
                                label = "Agreement Received" 
                                value={downloadUserAcc.agreementReceived}
                                onChange={(newValue) => {
                                  setDownloadUserAcc((downloadUserAcc) => {
                                  return { ...downloadUserAcc, agreementReceived: newValue };
                                  });
                                }}
                                renderInput={(params) => <TextField size='small' {...params} error={false}/>}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <DatePicker
                                id = "download-user-rejected"
                                label = "Rejected" 
                                value={downloadUserAcc.rejected}
                                onChange={(newValue) => {
                                  setDownloadUserAcc((downloadUserAcc) => {
                                  return { ...downloadUserAcc, rejected: newValue };
                                  });
                                }}
                                renderInput={(params) => <TextField size='small' {...params} error={false}/>}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <DatePicker
                                id = "download-user-updated"
                                label = "Updated" 
                                value={downloadUserAcc.updated}
                                onChange={(newValue) => {
                                  setDownloadUserAcc((downloadUserAcc) => {
                                  return { ...downloadUserAcc, updated: newValue };
                                  });
                                }}
                                renderInput={(params) => <TextField size='small' {...params} error={false}/>}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={"tablecellnoborder"}>
                              <DatePicker
                                id = "download-user-warningSent"
                                label = "Warning Sent" 
                                value={downloadUserAcc.warningSent}
                                onChange={(newValue) => {
                                  setDownloadUserAcc((downloadUserAcc) => {
                                  return { ...downloadUserAcc, warningSent: newValue };
                                  });
                                }}
                                renderInput={(params) => <TextField size='small' {...params} error={false}/>}
                              />
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                      <Grid>
                      <Table size="small">
                        <TableRow>
                          <TableCell className={"tablecellnoborder"}>
                            <FormGroup>
                              <FormControlLabel 
                                control={<Checkbox checked={downloadUserAcc.neverExpires} onChange={(e) => {
                                  setDownloadUserAcc((downloadUserAcc) => {
                                    return {
                                      ...downloadUserAcc,
                                      neverExpires: !downloadUserAcc.neverExpires,
                                    };
                                    });
                                    }}/>} 
                                  label="Never Expire" 
                              />
                            </FormGroup>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={"tablecellnoborder"}>
                            <FormGroup>
                              <FormControlLabel 
                                control={<Checkbox checked={downloadUserAcc.needsAgreement} onChange={(e) => {
                                  setDownloadUserAcc((downloadUserAcc) => {
                                    return {
                                      ...downloadUserAcc,
                                      needsAgreement: !downloadUserAcc.needsAgreement,
                                    };
                                    });
                                    }}/>} 
                                  label="Needs Agreement" 
                              />
                            </FormGroup>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={"tablecellnoborder"}>
                            <FormGroup>
                              <FormControlLabel 
                                control={<Checkbox checked={downloadUserAcc.requestLink} onChange={(e) => {
                                  setDownloadUserAcc((downloadUserAcc) => {
                                    return {
                                      ...downloadUserAcc,
                                      requestLink: !downloadUserAcc.requestLink,
                                    };
                                    });
                                    }}/>} 
                                  label="Request Link" 
                              />
                            </FormGroup>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={"tablecellnoborder"}>
                            <FormGroup>
                              <FormControlLabel 
                                control={<Checkbox checked={downloadUserAcc.requestXml} onChange={(e) => {
                                  setDownloadUserAcc((downloadUserAcc) => {
                                    return {
                                      ...downloadUserAcc,
                                      requestXml: !downloadUserAcc.requestXml,
                                    };
                                    });
                                    }}/>} 
                                  label="Request XML" 
                              />
                            </FormGroup>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={"tablecellnoborder"}>
                            <FormGroup>
                              <FormControlLabel 
                                control={<Checkbox checked={downloadUserAcc.revenue} onChange={(e) => {
                                  setDownloadUserAcc((downloadUserAcc) => {
                                    return {
                                      ...downloadUserAcc,
                                      revenue: !downloadUserAcc.revenue,
                                    };
                                    });
                                    }}/>} 
                                  label="Revenue" 
                              />
                            </FormGroup>
                          </TableCell>
                        </TableRow>
                      </Table>
                    </Grid>
                  </Grid>  
                </Box>  
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell align="right">
                        <Button
                          name="Save Message"
                          label="Save Message"
                          variant="outlined"
                          size="small"
                          onClick={(e) => updtUserAcc(downloadUserAcc)}
                        >
                          Update
                        </Button>
                      </TableCell>
                      <TableCell>
                        <Button
                          name="Delete Message"
                          label="Delete Message"
                          variant="outlined"
                          size="small"
                          onClick={(e) => delUserAcc(downloadUserAcc)}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          </Dialog>
        )
    )
}

export default DownloadUserAccForm;